export const environment = {
  production: false,
  capturas: 'https://api-captura-staging.ramper.com.br',
  api: '',
};
